(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counting-timer-section"] && !Shopify.designMode) return;
  try {
    


document.addEventListener("DOMContentLoaded", function () {
  const timer = document.querySelector(".datapage_line");
  if (!timer) return;

  const dateAttr = timer.getAttribute("data-datess");

  // FIX FOR IOS: Replace space with T for ISO format
  const safeDate = dateAttr.replace(" ", "T");

  // Convert to Sydney timezone safely
  const targetDate = new Date(
    new Date(safeDate).toLocaleString("en-US", { timeZone: "Australia/Sydney" })
  ).getTime();

  const daysEl = timer.querySelector(".dayss");
  const hoursEl = timer.querySelector(".hourss");
  const minutesEl = timer.querySelector(".minutess");
  const secondsEl = timer.querySelector(".secondss");

  function getAustraliaNow() {
    return new Date(
      new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" })
    ).getTime();
  }

  function updateTimer() {
    const now = getAustraliaNow();
    const distance = targetDate - now;

    if (distance <= 0) {
      daysEl.textContent = "00";
      hoursEl.textContent = "00";
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
      clearInterval(timerInterval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysEl.textContent = String(days).padStart(2, "0");
    hoursEl.textContent = String(hours).padStart(2, "0");
    minutesEl.textContent = String(minutes).padStart(2, "0");
    secondsEl.textContent = String(seconds).padStart(2, "0");
  }

  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
});


  } catch(e) { console.error(e); }
})();
})();
